import React from "react";
import {
    FaInfinity,
    FaLightbulb,
    FaUsers,
    FaCheckCircle,
    FaQuoteLeft,
    FaBuilding,
    FaMapMarkerAlt,
    FaShieldAlt,
    FaAward
} from "react-icons/fa";
import AboutBanner from "./AboutBanner";
import SisterConcerms from "./SisterConcerms";

// আপনার প্রজেক্ট অনুযায়ী ইমেজের পাথ ইম্পোর্ট করুন
import companyImg from "../../assets/gallery/greenland.jpg";

const OurStory = () => {
    return (
        <div className="about-us-wrapper bg-white">
            {/* 1. About Banner */}
            <AboutBanner
                title={"OUR STORY"}
                description={"Explore the story behind Iconic Greenland and our commitment to delivering trusted, sustainable, and value-driven developments."}
            />

            {/* 2. Our Story Section (Image + Content Layout) */}
            <section className="md:pb-5">
                <div className="container pb-4">


                    <div className="row g-5 align-items-center">
                        {/* Left Column: Image & Highlight Badge */}
                        <div className="col-lg-6">
                            <div className="position-relative">
                                <div className="rounded-4 overflow-hidden shadow-lg">
                                    <img
                                        src={companyImg}
                                        alt="Iconic Greenland Project"
                                        className="w-100 h-100 object-fit-cover"
                                        style={{ minHeight: "420px", maxHeight: "550px" }}
                                    />
                                </div>
                                {/* Floating Experience/Trust Badge */}
                                <div
                                    className="position-absolute bottom-0 start-0 m-4 p-3 bg-white shadow-lg rounded-3 d-flex align-items-center gap-3 border-start border-4 border-info d-none d-sm-flex"
                                    style={{ maxWidth: "280px" }}
                                >
                                    <FaShieldAlt size={36} className="text-info flex-shrink-0" />
                                    <div>
                                        <h6 className="fw-bold mb-0 text-dark">100% Legally Verified</h6>
                                        <small className="text-muted">Secure Land Ownership</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column: Narrative Content */}
                        <div className="col-lg-6">
                            <h3 className="fw-bold text-dark mb-3">
                                Transforming Dreams into Secure Land Investments
                            </h3>

                            <p className="text-muted leading-relaxed mb-3">
                                At <strong>Iconic Greenland</strong>, our story began with a simple yet powerful vision to make land ownership secure, transparent, and accessible for everyone. Recognizing the growing demand for trustworthy real estate investments, we set out to develop projects that combine strategic locations, legal assurance, and long-term value.
                            </p>

                            <p className="text-muted leading-relaxed mb-4">
                                We believe that purchasing land is one of life’s most significant investments. Every project we undertake is selected after thorough research, rigorous legal verification, and meticulous planning to ensure complete peace of mind for modern investors and families.
                            </p>

                            {/* Highlight Cards Grid */}
                            <div className="row g-3 mb-4">
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center gap-2 p-2 rounded bg-white shadow-sm border">
                                        <FaCheckCircle style={{ color: '#BD06D3' }} />
                                        <span className="fw-semibold text-dark small">Trusted Land Developer</span>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center gap-2 p-2 rounded bg-white shadow-sm border">
                                        <FaCheckCircle style={{ color: '#BD06D3' }} />
                                        <span className="fw-semibold text-dark small">Legally Verified Projects</span>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center gap-2 p-2 rounded bg-white shadow-sm border">
                                        <FaCheckCircle style={{ color: '#BD06D3' }} />
                                        <span className="fw-semibold text-dark small">Prime Strategic Locations</span>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center gap-2 p-2 rounded bg-white shadow-sm border">
                                        <FaCheckCircle style={{ color: '#BD06D3' }} />
                                        <span className="fw-semibold text-dark small">Customer-Centric Approach</span>
                                    </div>
                                </div>
                            </div>

                            {/* Founder Quote */}
                            <div className="p-3 rounded-3 bg-white border-start border-4 shadow-sm" style={{ borderColor: '#BD06D3' }}>
                                <p className="fst-italic text-muted small mb-1">
                                    <FaQuoteLeft className="me-2 opacity-50" style={{ color: '#BD06D3' }} />
                                    "We don't just develop land we create opportunities for families, businesses, and future generations to build their dreams with confidence."
                                </p>
                                <small className="fw-bold text-dark d-block text-end">Founder, Iconic Unity Group</small>
                            </div>
                        </div>
                    </div>

                    {/* 3. Horizontal Timeline / Milestones */}
                    <div className="mt-5 pt-4 border-top">
                        <h4 className="fw-bold text-center text-dark mb-4">Our Growth Journey</h4>
                        <div className="row g-4 text-center">
                            <div className="col-md-3 col-6">
                                <div className="p-3 bg-white rounded-4 shadow-sm h-100 border">
                                    <div className="bg-info bg-opacity-10 text-info rounded-circle d-inline-flex p-3 mb-2">
                                        <FaBuilding size={24} />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1">2022</h5>
                                    <p className="small text-muted mb-0">Company Established</p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="p-3 bg-white rounded-4 shadow-sm h-100 border">
                                    <div className="p-3 rounded-circle d-inline-flex mb-2" style={{ backgroundColor: 'rgba(189, 6, 211, 0.1)', color: '#BD06D3' }}>
                                        <FaMapMarkerAlt size={24} />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1">2023</h5>
                                    <p className="small text-muted mb-0">First Residential Project</p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="p-3 bg-white rounded-4 shadow-sm h-100 border">
                                    <div className="bg-info bg-opacity-10 text-info rounded-circle d-inline-flex p-3 mb-2">
                                        <FaAward size={24} />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1">2024 - 2025</h5>
                                    <p className="small text-muted mb-0">Expansion & Growing Trust</p>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="p-3 bg-white rounded-4 shadow-sm h-100 border">
                                    <div className="p-3 rounded-circle d-inline-flex mb-2" style={{ backgroundColor: 'rgba(189, 6, 211, 0.1)', color: '#BD06D3' }}>
                                        <FaShieldAlt size={24} />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-1">Future</h5>
                                    <p className="small text-muted mb-0">Sustainable Communities</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4. Core Values Section */}
            <section className="md:py-5 bg-white border-top border-bottom">
                <div className="container py-4">
                    <div className="text-center max-w-2xl mx-auto mb-5">
                        <span className="text-info text-uppercase fw-bold tracking-wider small">
                            What Guides Us
                        </span>
                        <h2 className="display-6 fw-bold text-dark mt-2">
                            OUR CORE <span style={{ color: '#BD06D3' }}>VALUES</span>
                        </h2>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center rounded-4 bg-light">
                                <div className="mb-3 text-info">
                                    <FaInfinity size={40} />
                                </div>
                                <h4 className="fw-bold text-dark mb-3">Integrity</h4>
                                <p className="text-muted mb-0">
                                    We operate with honesty, transparency, and strong ethical standards, building lifelong trust with our clients and land owners.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center rounded-4 bg-light">
                                <div className="mb-3" style={{ color: '#BD06D3' }}>
                                    <FaLightbulb size={40} />
                                </div>
                                <h4 className="fw-bold text-dark mb-3">Innovation</h4>
                                <p className="text-muted mb-0">
                                    Innovation is at our core. We integrate modern master planning and sustainable infrastructure techniques in every plot development.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center rounded-4 bg-light">
                                <div className="mb-3 text-info">
                                    <FaUsers size={40} />
                                </div>
                                <h4 className="fw-bold text-dark mb-3">Customer First</h4>
                                <p className="text-muted mb-0">
                                    Our clients’ satisfaction defines our success. We focus on understanding their investment needs and delivering value beyond expectations.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 5. Sister Concerns Section */}
            <div className="py-4">
                <SisterConcerms />
            </div>
        </div>
    );
};

export default OurStory;